import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Commercial, Family, SmallBusiness } from '../assets/images';
import { Benefits, Eligibilities } from '@legalshield/legalshield-member-react-common';

export const useQuery = (): URLSearchParams => {
  const search = useLocation().search;
  return useMemo(() => new URLSearchParams(search), [search]);
};

export const getHeaderImage = (productType?: string): string => {
  if (productType?.includes('business')) return SmallBusiness;
  if (productType?.includes('cdlp')) return Commercial;
  return Family;
};

export const getSupplementTitle = (eligibilities: Eligibilities): string => {
  let title = '';

  eligibilities?.supplementBenefits.forEach((supplement: Benefits) => {
    if (!title.includes(supplement.friendlyName)) {
      title = title !== '' ? `${title}, ${supplement.friendlyName}` : supplement.friendlyName;
    }
  });

  return title.replace(/,(?=[^,]*$)/, ` ${string_table.AND}`);
};

export function interpolate(s: string, ...args: string[]): string {
  for (let i = 0; i < args.length; i++) {
    const template = '${' + i + '}';
    while (s.includes(template)) {
      s = s.replace(template, args[i]);
    }
  }
  return s;
}

export function contractUrlWithId(contractId: string | undefined): string {
  if (!contractId) return '';
  // Check if contractId is already a URL
  if (/^https?:\/\//i.test(contractId)) {
    return contractId;
  }
  if (/\.pdf$/i.test(contractId)) {
    return `https://contracts.legalshield.com/EmailContracts/${contractId}`;
  }
  return `https://contracts.legalshield.com/EmailContracts/${contractId}.pdf`;
}
